<script lang="ts">
	//Event dispatcher
	import { createEventDispatcher } from 'svelte';

	//Helpers
	import { combineLists } from './schedules';
	import { is_gen_2 } from './../../../../helpers/interface_helpers';
	import WeekDaysSelected from 'src/components/TimePicker/WeekDaysSelected.svelte';

	//Types
	import type { Device } from '../../../../types/Device.js';

	//Design system components
	import {
		ActionsContainer,
		AdvancedCard,
		IconButton,
		LabelList,
		Stack,
		Toggle,
	} from '@Shelly/shelly-design-system';
	import { format } from 'svelte-i18n';

	export let schedule_rules = [],
		checked = false,
		tempRange = false,
		device: Device,
		disabled = false;

	const dispatcher = createEventDispatcher();
</script>

<Stack gap="s">
	{#each schedule_rules as schedule, i}
		{#if !is_gen_2(device)}
			{#key schedule.days}<!--this is because we need to update selection of days-->
				<AdvancedCard title="Condition/Action" hideSlotTitle={false}>
					<WeekDaysSelected mondayIndex={0} selection={schedule.days} slot="title" />

					<LabelList
						size="m"
						labelList={combineLists(schedule, tempRange, device, checked)}
						slot="main"
					/>

					<ActionsContainer orientation="vertical" type="simple" slot="right">
						<IconButton
							icon="fas fa-pen"
							slot="first"
							variant="primary"
							{disabled}
							on:click={() => dispatcher('edit', { rule: schedule, index: i })}
							aria-label={$format('button_edit', { default: 'Edit' })}
						/>
						<IconButton
							class="align-self-center"
							icon="fas fa-trash"
							variant="danger"
							slot="second"
							{disabled}
							on:click={() => dispatcher('delete', i)}
							aria-label={$format('button_delete', { default: 'Delete' })}
						/>
					</ActionsContainer>
				</AdvancedCard>
			{/key}
		{:else}
			{#key schedule.days}
				<AdvancedCard title="Condition/Action" hideSlotTitle={false} leftSlotBackground>
					<Toggle
						size="m"
						checked={schedule.enabled}
						on:click={(e) => {
							e.stopPropagation();
							schedule.enabled = !schedule.enabled;
							dispatcher('toggle', { schedule, i });
						}}
						slot="left"
						id="toggle-q9t7kx3"
						aria-label={$format('label_enable_schedule', {
							default: 'Enable schedule',
						})}
					/>
					<WeekDaysSelected mondayIndex={1} selection={schedule.days} slot="title" />
					<LabelList
						size="m"
						labelList={schedule.labels.map((i) => ({
							...i,
							type: schedule.enabled === true ? null : 'disabled',
						}))}
						slot="main"
					/>
					<ActionsContainer orientation="vertical" type="simple" slot="right">
						<IconButton
							variant="primary"
							icon="fas fa-pen"
							slot="first"
							{disabled}
							on:click={() => dispatcher('edit', { rule: schedule, index: i })}
							aria-label={$format('button_edit', { default: 'Edit' })}
						/>
						<IconButton
							icon="fas fa-trash"
							variant="danger"
							slot="second"
							{disabled}
							on:click={() => dispatcher('delete', i)}
							aria-label={$format('button_delete', { default: 'Delete' })}
						/>
					</ActionsContainer>
				</AdvancedCard>
			{/key}
		{/if}
	{/each}
</Stack>
